import Vue from 'vue'
import VueResource from 'vue-resource'
import { orderBy } from 'lodash-es'

Vue.use(VueResource)

export default {
    getObjects: (context, payload) => {
        let callback = typeof payload === undefined? () => {}: payload
        Vue.http.post(
            context.getters.endpoint + '/db/objects', {}, { headers: context.state.restrictedHeaders }
        ).then( (o) => {
            let user = o.data
            if (!user.result && flow == 'resume') {
                context.dispatch('deauthorizeUser')
            }
            delete user.result
            context.commit('updateUserData', user)
            callback && callback()
        })
    }
}